let apiHost
let loginApiHost
if (process.env.NODE_ENV === 'production') {
    // api 测试环境
    apiHost = '//active.yunhou.com/api';
    // loginApiHost = '//active.yunhou.com/api'
} else {
    // api 开发环境
    apiHost = '//active.yunhou.com/api';
    // loginApiHost = '//active.yunhou.com/api'
}
// 图片静态资源
const staticImg4 = '//img4.bbgstatic.com/'
export default {
    apiHost,
    loginApiHost,
    staticImg4
}



// WEBPACK FOOTER //
// ./src/config.js